/* eslint-disable no-param-reassign */
export default {
  SET_USERINFO(state, payload) {
    state.token = payload.token;
    state.deviceId = payload.deviceId;
  },
  // 设置来源
  SET_FROM(state, payload) {
    state.openFrom = payload.openFrom;
    state.isShowHeader = payload.isShowHeader;
  },

  // 记录手机号
  SET_USERPHONE(state, payload) {
    state.userPhone = payload;
  },
};



// WEBPACK FOOTER //
// ./src/pages/Application/store/mutations.js